import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';

export function useRevokeApiKey(organizationId: number) {
  const { getAccessToken } = useAuth();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (keyId: number): Promise<void> => {
      const client = createApiClient(getAccessToken);
      await client.DELETE('/api/organizations/{organizationId}/api-keys/{keyId}', {
        params: {
          path: { organizationId, keyId },
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys', organizationId] });
    },
  });

  return {
    revokeApiKey: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
}
